// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__taT2k","title":"styles_title__c0_4h","subtitle":"styles_subtitle__2OgeO","tabs":"styles_tabs__grVos"};